import { Separator } from '@zep-us/zus';
import { UserAvatar } from '@/shared/features/user-avatar';
import { type QuizBankAuthor, type QuizBankStandard } from '../types';
import { QuizBankSearchHitText } from './QuizBankSearchHitText';
import { QuizBankStandardCode } from './QuizBankStandardCode';
const NO_HIT_TERMS: readonly string[] = [];
interface QuizBankProblemCardFooterProps {
  standard: QuizBankStandard;
  author: QuizBankAuthor;
  /** 단원명에 칠할 검색어 토큰 */
  hitTerms?: readonly string[];
  /** 성취기준 배지를 검색어 hit 로 칠한다 */
  standardHit?: boolean;
  /** 단원명 클릭 — 성취기준 칩처럼 그 이름을 검색어로 건다 */
  onUnitClick?: (unitName: string) => void;
  onStandardClick?: (standard: QuizBankStandard) => void;
}

/**
 * 카드 하단 메타 — 작성자 | 단원 | 성취기준.
 * 단원은 서버가 주는 값이고, 미이행 문항이면 없어서 생략한다. 영역명(수와 연산 등)은 보여주지 않는다 —
 * 단원명만으로 충분하고, 서버도 검색 응답에서 내리지 않는다.
 */
export const QuizBankProblemCardFooter = ({
  standard,
  author,
  hitTerms = NO_HIT_TERMS,
  standardHit = false,
  onUnitClick,
  onStandardClick
}: QuizBankProblemCardFooterProps) => {
  const unitName = standard.unitName;
  return <div className="flex w-full min-w-0 flex-wrap items-center gap-xs text-body-sm-medium text-neutral" data-sentry-component="QuizBankProblemCardFooter" data-sentry-source-file="QuizBankProblemCardFooter.tsx">
      <span className="flex min-w-0 items-center gap-3xs text-default">
        {/* avatarData 가 null 이면 UserAvatar 가 FallbackAvatar 를 그린다 */}
        <UserAvatar avatarData={author.avatarData} size="xxs" className="shrink-0" data-sentry-element="UserAvatar" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />
        <span className="truncate">{author.name}</span>
      </span>

      {unitName && <>
          <Separator orientation="vertical" className="h-[12px] self-center bg-gray-300" />
          {onUnitClick ? <button type="button" data-testid="quiz-bank-unit-name-chip" className="max-w-full truncate rounded-xs underline-offset-2 hover:underline focus-visible:focus-ring" onClick={event => {
        // 카드 전체가 선택 토글이라 단원 클릭이 번지지 않게 막는다.
        event.stopPropagation();
        onUnitClick(unitName);
      }}>
              <QuizBankSearchHitText text={unitName} hitTerms={hitTerms} />
            </button> : <span className="truncate">
              <QuizBankSearchHitText text={unitName} hitTerms={hitTerms} />
            </span>}
        </>}

      <Separator orientation="vertical" className="h-[12px] self-center bg-gray-300" data-sentry-element="Separator" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />

      <QuizBankStandardCode code={standard.code} description={standard.description} hit={standardHit} onClick={() => onStandardClick?.(standard)} data-sentry-element="QuizBankStandardCode" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />
    </div>;
};